import { useAuth } from '../contexts/AuthContext';

/**
 * What the console shows instead of a protected screen while the session is not proven (#583 S5).
 * It carries no operator or family data: the protected screens are unmounted, not hidden.
 */
export default function SessionGate() {
  const { status, resume, logout } = useAuth();

  if (status === 'covered') {
    return (
      <main className="session-gate">
        <div className="session-gate-card">
          <h1>Console covered</h1>
          <p>Protected data is hidden while you are away. Press any key or choose Continue to check your session.</p>
          {/* AuthContext consumes covered clicks in capture and calls resume before onClick. */}
          <button type="button" className="btn btn-primary" onClick={resume}>Continue</button>
        </div>
      </main>
    );
  }

  if (status === 'unavailable') {
    return (
      <main className="session-gate">
        <div className="session-gate-card" role="alert">
          <h1>Session not confirmed</h1>
          <p>The server could not confirm your operator session. No data is shown until it does.</p>
          <div className="session-gate-actions">
            <button type="button" className="btn btn-primary" onClick={resume}>Retry</button>
            <button type="button" className="btn btn-outline" onClick={logout}>Sign out</button>
          </div>
        </div>
      </main>
    );
  }

  return (
    <main className="session-gate" aria-busy="true">
      <div className="session-gate-card">
        <p>{status === 'signingOut' ? 'Signing out…' : 'Checking your operator session…'}</p>
      </div>
    </main>
  );
}
